import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'; 
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

const ELASTICSEARCH_URL = environment.baseElasticSearchUrl;
const NOTIFICATION_API = environment.marketplaceNotificationsApi;
const PLATFORMENDPOINT = environment.platformEndpoint;

@Injectable({
  providedIn: 'root'
})

export class PropertyValuationService {

    // private valuationApiUrl = "https://mbe15fql55.execute-api.us-east-1.amazonaws.com/qa/evaluations";
    private valuationApiUrl = PLATFORMENDPOINT+"/valuations/requests"
    private signedUrlApi = "https://80y18zgl96.execute-api.us-east-1.amazonaws.com/uat/documents";

    private baseElasticSearchUrl = ELASTICSEARCH_URL;
    private valuationNotificationApi = NOTIFICATION_API+"/valuation"; //from market-welcome-api-stack
    

    constructor(private http: HttpClient) { }

    public getProposalDocument(body: any){
        const headers = this.createReqHeader();
        return this.http.post<any>(this.signedUrlApi, body, {headers: headers});
    }

    requestPropertyEvaluation(property: any){
        let headers = this.createReqHeader();
        return this.http.post<any>(`${this.valuationApiUrl}`, property, { headers: headers });
    }

    getAllValuations(){
        let header = this.createReqHeader();
        return this.http.get<any>(this.valuationApiUrl, {headers: header});
    }

    getAllValuationsByOwnerID(ownerId: any){
        let header = this.createReqHeader();
        return this.http.get<any>(this.valuationApiUrl+"/"+ownerId, {headers: header});
    }

    onEvaluationSearch(valuationQuery: any){
        let headers = this.createReqHeader();    //SimpleReqHeader
        return this.http.post<any>(this.baseElasticSearchUrl + "/valuations_index/_search?size=100", valuationQuery, { headers: headers });
    }
    
    onQuerySearch(body: any) {
        let headers = this.createReqHeader();    //SimpleReqHeader
        return this.http.post<any>(this.baseElasticSearchUrl + "/valuations_index/" + "_search?size=100", body, { headers: headers });
    }

    updateValuation(body: any){
        let headers = this.createReqHeader();
        return this.http.put<any>(this.valuationApiUrl+"/request/"+body.id, body, {headers: headers});
    }

    sendValuationNotification(body: any){
        let headers = this.createReqHeader();
        return this.http.post<any>(this.valuationNotificationApi, body, { headers: headers});
    }

    private createReqHeader() {
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    }
}